<template>
  <div class="d-flex align-center p-pointer">
    <span class="api-btn p-fs-xs d-none d-sm-flex" @click="goApiKeyPage">
      {{ label.button.addKey }}
    </span>

    <span class="api-btn p-fs-xs d-sm-none">
      <v-icon class="first--text" small @click="goApiKeyPage">
        mdi-key
      </v-icon>
    </span>
  </div>
</template>

<script>
import label from "@/lang/StaticLabels.js";

export default {
  name: "ApiKey",
  data() {
    return {
      label,
    };
  },
  methods: {
    goApiKeyPage() {
      this.$router
        .push({
          name: "AddApiKey",
        })
        .catch(() => {});
    },
  },
};
</script>
